import React from "react";
import strings from "../../helpers/Localization";
import IconComponent from "../Icons/IconComponent";

//mui datepicker
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
//import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
//import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
//

import InputContainer from "./InputContainer";
import TextField from "./TextField";
import TextArea from "./TextArea";
import Dropdown from "./Dropdown";
import Toggle from "./Toggle";
import PrefixedTextField from "./PrefixedTextField";
import ImportFile from "./ImportFile";
import DateTimePicker from "../DatePicker/DateTimePicker";
import PhoneInputFormatted from "./PhoneInputFormatted";

const Inputs = ({ field, noLabel, forceOpenTop }) => {
    const [openDTP, setopenDTP] = React.useState(false);

    const getTranslation = (json, lang, useValue) => {
        if (!json || json === "") {
            return "";
        }
        try {
            const translation = JSON.parse(json);
            return (useValue ? translation[lang].value : translation[lang]) || "";
        }
        catch {
            return "";
        }
    };
    const setTranslation = (callback, originaljson, value, lang, useValue) => {
        let item = {};
        if (!originaljson || originaljson === "") {
            try {
                item = JSON.parse(originaljson);
            }
            catch {
                item = {};
            }
        }
        item[lang] = useValue ? { value: value } : value;
        callback({ value: JSON.stringify(item) });
    };

    if (field === null || field.hide) {return null;}
    let inside = null;
    let titlePosition = "center";
    const fileInput = null;
    const openTop = forceOpenTop ? forceOpenTop : field.openTop;

    switch (field.type) {
        case "textfield": inside = <TextField
            allowCopy={field.allowCopy}
            disabled={field.disabled}
            placeholder={field.placeholder}
            value={field.value}
            maxlength={field.maxlength}
            onChange={field.onChange}
            widthTextfield={field.widthTextfield}
        />;
            break;
        case "translatedTextField": inside = <TextField
            allowCopy={field.allowCopy}
            disabled={field.disabled}
            placeholder={field.placeholder}
            value={getTranslation(field.value, field.lang, field.useValue)}
            onChange={(e) => {setTranslation(field.onChange, field.value, e.target.value, field.lang, field.useValue);}}
            widthTextfield={field.widthTextfield}
        />;
            break;
        case "text": inside = <div className="ContentName">{field.value}</div>;
            break;
        case "prefixedTextfield": inside = <PrefixedTextField
            prefix={field.prefix}
            disabled={field.disabled}
            placeholder={field.placeholder}
            value={field.value}
            onChange={field.onChange}
        />;
            break;
        case "phone": inside = <PhoneInputFormatted
            disabled={field.disabled}
            placeholder={field.placeholder}
            value={field.value}
            onChange={field.onChange}
        />;
            break;
        case "textarea": inside = <TextArea
            disabled={field.disabled}
            placeholder={field.placeholder}
            value={field.value}
            onChange={field.onChange}
        />;
            break;
        case "togglebuttons": inside = <div style={{ display: "flex", flexGrow: "1", flexDirection: "column", flexShrink: "0", gap: "10px" }}> {
            field.elements.map((el, index) => {
                return <Toggle
                    key={index}
                    type="switch"
                    disabled={el.disabled}
                    name={el.name}
                    checked={el.checked}
                    onClick={el.onClick}
                />;
            })
        } </div>;
            titlePosition = "flex-start";
            break;
        case "togglebutton": inside = <Toggle
            type="switch"
            disabled={field.disabled}
            name={field.name}
            checked={field.checked}
            redUnchecked={field.redUnchecked}
            onClick={field.onClick}
            extentedClick={field.extentedClick}
            fontSizeText={field.fontSizeText}
        />;
            titlePosition = "flex-start";
            break;
        case "squareradiobuttons": inside = <div style={{ display: "flex", flexGrow: "1", flexDirection: field.flexDirection ? field.flexDirection : "row", flexShrink: "0", gap: field.gap ? field.gap : "20px" }}> {
            field.elements && field.elements.map((el, index) => {
                return <Toggle
                    key={index}
                    type="check"
                    disabled={el.disabled}
                    name={el.name}
                    checked={el.checked}
                    onClick={el.onClick}
                />;
            })
        } </div>;
            break;
        case "circlesquareradiobuttons": inside = <div style={{ display: "flex", flexGrow: "1", flexDirection: field.flexDirection ? field.flexDirection : "row", flexShrink: "0", gap: field.gap ? field.gap : "20px" }}> {
            field.elements && field.elements.map((el, index) => {
                return <Toggle
                    key={index}
                    type="checkCircle"
                    disabled={el.disabled}
                    name={el.name}
                    checked={el.checked}
                    onClick={el.onClick}
                />;
            })
        } </div>;
            break;
        case "importfile":
            inside = <ImportFile
                disabled={field.disabled}
                value={field.value}
                access={field.access}
                thumbnail={field.thumbnail}
                onAddFiles={field.onAddFiles}
                onOpenModal={field.onOpenModal}
                onDeleteFiles={field.onDeleteFiles}
            />;
            break;
        case "selectElement":
            if (field.selectedElementId === undefined) {field.selectedElementId = null;}
            inside = field.elementsList ?
                <Dropdown
                    openTop={field.openTop}
                    disabled={field.disabled}
                    adjustHeight={field.adjustHeight}
                    list={field.elementsList.results}
                    value={field.selectedElementId}
                    emptyTitle={field.placeholder ? field.placeholder : strings.None}
                    placeHolder={field.placeholder ? field.placeholder : ""}
                    preventEmpty={field.preventEmpty}
                    onChange={(option) => {
                        if (!option) {field.onSelectElement(null);}
                        else {field.onSelectElement(field.elementsList.results.find(el => el && el.id.toString() === option.id.toString() ));}
                    }}
                /> : null;
            break;
        case "listElement":
            const choosefromlist = field.choosefromlist ? field.choosefromlist.results : [];
            if (!field.canaddmultipletime) {
                inside = <div style={{ display: "flex", flexGrow: "1", flexDirection: "column", flexShrink: "0", gap: "10px", maxHeight: "200px", overflowY: "auto" }}> {
                    choosefromlist.map((el, index) => {
                        return (
                            <Toggle
                                key={index}
                                type="switch"
                                disabled={field.disabled || field.lockedIds && field.lockedIds.includes(el.id)}
                                name={el.name}
                                checked={field.currentlist.some(z => z.id === el.id)}
                                onClick={
                                    () => {
                                        if (field.currentlist.some(z => z.id === el.id)) {
                                            field.onRemove(el);
                                        }
                                        else {
                                            field.onAdd(el);
                                        }
                                    }
                                }
                            />
                        );
                    })
                } </div>;
            }
            break;
        case "checkableDropdown": inside = <div className="TextField-small-filled"
            style={{ flexGrow: "1", flexShrink: "0", fontSize: "14px", backgroundColor: "var(--input-background)", color: !field.value || field.value.length < 1 ? "#0000004D" : null, justifyContent: "space-between" }}
            onClick={field.onClick}>
            <span style={{
                width: "300px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flexGrow: "1",
                marginRight: "10px"
            }}>{field.value && field.value.length > 0 ? field.value.map(item => item.name).join(", ") : field.placeholder}</span>
            <IconComponent nameIcon="chevronRight" color="grey"/>
        </div>;
            break;
        case "dateTimeSelector": inside = <>
            <TextField
                fixedValue={true}
                disabled={field.disabled}
                datePickerIcon={true}
                value={field.value && field.value !== "" ? dayjs(field.value).format("DD-MM-YYYY HH:mm") : null}
                onClick={() => {
                    setopenDTP(true);
                }}
            />
            <DateTimePicker
                open={openDTP}
                title={field.modalTitle}
                currentValue={field.value ? field.value : null}
                onClose={() => {
                    setopenDTP(false);
                }}
                onValidate={(newDate) => {
                    field.onChange(newDate);
                    setopenDTP(false);
                }}
            />
        </>;
            break;
        case "custom": inside = field.child;
            break;
        case "divider": return <span style={{ height: "1px", flexGrow: "1", flexShrink: "0", background: "rgba(0, 0, 0, 0.12)" }}/>;
    }

    return <InputContainer
        title={field.title}
        iconTitle={field.iconTitle}
        bold={field.bold}
        fontSize14={field.fontSize14}
        width={field.width}
        spaceBetween={field.spaceBetween}
        flexDirectionHorizontalFlexContainer={field.flexDirectionHorizontalFlexContainer}
        gapHorizontalFlexContainer={field.gapHorizontalFlexContainer}
        alignItemsHorizontalFlexContainer={field.alignItemsHorizontalFlexContainer}
        heightHorizontalFlexContainer={field.heightHorizontalFlexContainer}
        widthHorizontalFlexContainer={field.widthHorizontalFlexContainer}
    >
        {inside}
    </InputContainer>;
};

export default Inputs;
